import { InputBaseProps } from '@mui/material/InputBase';
import MUIInput from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

const StyledTextedField = styled(MUIInput)(({ theme, ...props }) => {
  return props.label
    ? {
        paddingTop: 28,
        '& > label': {
          position: 'relative',
          fontWeight: 500,
          transform: 'none !important',
        },
      }
    : {};
});

type InputProps = Omit<
  React.ComponentProps<typeof MUIInput> & {
    ariaLabel?: string;
    defaultValue?: string;
    readOnly?: boolean;
    InputProps?: Partial<InputBaseProps>;
    isRequired?: boolean;
    isInvalid?: boolean;
    isDisabled?: boolean;
    errorMessage?: string;
    ['data-testid']?: string;
  },
  'helperText'
>;

const Input = forwardRef<
  React.ElementRef<typeof MUIInput>,
  Readonly<InputProps>
>(
  (
    {
      ariaLabel,
      onChange = () => {},
      defaultValue,
      id,
      name,
      isDisabled,
      disabled,
      isInvalid,
      error,
      isRequired,
      required,
      InputProps,
      readOnly,
      slotProps,
      errorMessage,
      ...props
    },
    ref,
  ) => {
    const dataTestId = props['data-testid'];

    return (
      <StyledTextedField
        aria-label={ariaLabel ?? props['aria-label']}
        inputRef={ref}
        size="small"
        variant="outlined"
        id={id ?? name}
        name={name}
        key={defaultValue}
        defaultValue={defaultValue}
        onChange={onChange}
        helperText={error && errorMessage}
        error={isInvalid || error}
        required={isRequired || required}
        disabled={isDisabled || disabled}
        slotProps={{
          inputLabel: {
            shrink: true,
          },
          htmlInput: {
            'data-testid': dataTestId,
          },
          input: {
            readOnly,
            ...InputProps,
          },
          ...slotProps,
        }}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';

export default Input;
